import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { AddCostComparisonDialogComponent } from './add-cost-comparison-dialog.component';

@NgModule({
    declarations: [AddCostComparisonDialogComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [AddCostComparisonDialogComponent]
})
export class AddCostComparisonDialogModule { }
